module.exports = __webpack_public_path__ + "static/media/PlayfairDisplay-Regular.6eae5de9.ttf";